import React from 'react';
import PropTypes from 'prop-types';
import colors from '../colors';
import cx from '../clsx';

function StravaLogo({ alt, className, width, height, fill, style, ...props }) {
  return (
    <svg
      alt={alt}
      viewBox="0 0 200 42"
      className={cx(className)}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', width, height, ...style }}
      {...props}
    >
      <g fill={fill}>
        <path d="M19.2 40.4c-3.8 0-7.4-0.5-10.6-1.6 -3.3-1.1-6.1-2.6-8.5-4.7l6.7-7.9c2 1.6 4.2 2.7 6.4 3.4 2.2 0.7 4.5 1 6.7 1 1.1 0 2-0.1 2.5-0.4 0.5-0.3 0.7-0.7 0.7-1.2v-0.1c0-0.5-0.4-1-1.1-1.3 -0.7-0.4-2.1-0.7-4.1-1.1 -2.1-0.4-4.1-0.9-6-1.5 -1.9-0.6-3.6-1.3-5-2.2 -1.4-0.9-2.6-2-3.4-3.4 -0.9-1.4-1.3-3-1.3-5v-0.1c0-1.8 0.3-3.4 1-5 0.7-1.5 1.7-2.9 3-4 1.3-1.1 3-2 5-2.7 2-0.6 4.2-1 6.8-1 3.6 0 6.8 0.4 9.5 1.3 2.7 0.8 5.2 2.1 7.3 3.8l-6.1 8.4C26.9 13.9 25 13 23 12.4c-2-0.6-3.8-0.9-5.6-0.9 -0.9 0-1.6 0.1-2.1 0.4 -0.5 0.3-0.7 0.7-0.7 1.1v0.1c0 0.5 0.3 0.9 1 1.3 0.7 0.4 2 0.7 3.9 1.1 2.4 0.4 4.6 0.9 6.5 1.5 2 0.6 3.6 1.4 5 2.3 1.4 0.9 2.5 2.1 3.3 3.4 0.8 1.3 1.1 2.9 1.1 4.8v0.1c0 2-0.4 3.7-1.2 5.3 -0.8 1.6-1.9 2.9-3.3 4 -1.4 1.1-3.2 1.9-5.2 2.5C24 40.1 21.7 40.4 19.2 40.4L19.2 40.4z" />
        <polygon points="46 12.9 35 12.9 35 2.3 69.4 2.3 69.4 12.9 58.4 12.9 58.4 39.7 46 39.7 " />
        <path d="M89.1 20.1c1.5 0 2.7-0.3 3.5-1 0.9-0.6 1.3-1.5 1.3-2.7v-0.1c0-1.2-0.4-2.1-1.3-2.7 -0.8-0.6-2-0.9-3.5-0.9h-5.4v7.3H89.1L89.1 20.1zM71.2 2.3h18.3c3.3 0 6.1 0.4 8.2 1.1 2.2 0.8 3.9 1.8 5.2 3.1 1.1 1.1 2 2.4 2.6 3.8 0.6 1.4 0.9 3.1 0.9 5v0.1c0 2.7-0.7 5.1-2 6.9 -1.3 1.9-3.1 3.4-5.4 4.5l8.7 12.7H93.4l-7-10.7h-0.1 -2.6v10.7H71.2V2.3L71.2 2.3z" />
        <polygon points="179.9 23.6 188 39.7 200 39.7 179.9 0 159.8 39.7 171.8 39.7 " />
        <polygon points="151.9 18.4 143.8 2.3 131.8 2.3 151.9 42 172 2.3 160.1 2.3 " />
        <polygon points="123.9 23.6 132.1 39.7 144 39.7 123.9 0 103.8 39.7 115.8 39.7 " />
      </g>
    </svg>
  );
}

StravaLogo.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
  style: PropTypes.shape({})
};

StravaLogo.defaultProps = {
  alt: 'Strava',
  className: undefined,
  height: 'auto',
  width: 'auto',
  style: {},
  fill: colors.O50_STRAVA_ORANGE
};

export default StravaLogo;
